<section>
  <div class="row mx-0" [hidden]="!isFormView()">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-register-advance-invoice-concept [advanceInvoiceModel]="advanceInvoiceModel()"
        [advanceInvoiceConceptContract]="advanceInvoiceConcept" (updateListConcept)="getUpdateListConcept()"
        (isFormView)="getFormView($event)"></app-register-advance-invoice-concept>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
    <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
      (onRecoverData)="getConceptsAdvanceInvoiceWithPagination()" (onAction)="onAction($event)"
      (onPageChange)="onPageChange($event)"></app-custom-table>
  </div>
</section>